import { render } from "./MemosChiefList.vue?vue&type=template&id=bb3cf2a4&scoped=true"
import script from "./MemosChiefList.vue?vue&type=script&lang=js"
export * from "./MemosChiefList.vue?vue&type=script&lang=js"

import "./MemosChiefList.vue?vue&type=style&index=0&id=bb3cf2a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb3cf2a4"]])

export default __exports__